export { default } from 'features/reward/routes/loyalty-history-modal-route';
